import en from './en'
import zh from './zh'
import zh_tc from './zh_tc'

export default {
  en,
  zh,
  zh_tc,
}
